import React from 'react';

import Arrowwhite from '../img/arrowwhite.svg';

const regions = ['NORTHLAND','AUCKLAND', 'BAY OF PLENTY', 'HAWKE’S BAY', 'TARANAKI', 'MANAWATU', 'WELLINGTON' ,'NELSON', 'MARLBOROUGH' ,'WEST COAST' ,'CANTERBURY','SOUTH CANTERBURY','SOUTHLAND'];
const regionsList = regions.map((region,index)=><a href="/" key={index} className="custom_bodycontainer__sidebar---regionbox--link">{region}</a>)
class Sidebar extends React.Component {
    constructor(){
        super();

        this.state = {
        };
    }
    render() {
       return (
        <div className="custom_bodycontainer__sidebar">           
        <div className="custom_bodycontainer__sidebar---regionbox">
          <div className="custom_bodycontainer__sidebar---regionbox--titlebox">
            <p className="sidebar-title">regions</p>
          </div>
          <div className="custom_bodycontainer__sidebar---regionbox--linkbox">
            {regionsList}
          </div>
        </div>
        <div className="custom_bodycontainer__sidebar---readmorebox">
          <div className="custom_bodycontainer__sidebar---regionbox--titlebox2">
            <p className="sidebar-title">read more</p>
          </div>
          <a href="https://www.stuff.co.nz/national/121941942/addicted-to-digital-news-sinead-bouchers-history-with-stuff" rel="noopener noreferrer" target="_blank" className="custom_bodycontainer__sidebar---readmorebox--each custom_bodycontainer__sidebar---readmorebox--each---worldnews">
            <div className="custom_bodycontainer__sidebar---readmorebox--each---titlebox">
            <div className="custom_bodycontainer__mainpage--body---label--colorsection2 custom_bodycontainer__mainpage--body---label--colorsection2---national">
                <img className="arrow-img" src={Arrowwhite} alt="arrowwhite" />
            </div>
            <div className="custom_bodycontainer__mainpage--body---label--textsection3 pointernone">national news</div>
            <a className="app-user-link-a app-user-link-a--3" href="https://www.stuff.co.nz/national/121941942/addicted-to-digital-news-sinead-bouchers-history-with-stuff" rel="noopener noreferrer" target="_self">IOS app users please click <span className="app-user-link">here</span></a>
            </div>
          </a>
          <a href="http://www.stuff.co.nz/national/quizzes/300037800/quiz-20-years-of-news-in-new-zealand" rel="noopener noreferrer" target="_blank" className="custom_bodycontainer__sidebar---readmorebox--each custom_bodycontainer__sidebar---readmorebox--each---sport">
          <div className="custom_bodycontainer__sidebar---readmorebox--each---titlebox">
            <div className="custom_bodycontainer__mainpage--body---label--colorsection2 custom_bodycontainer__mainpage--body---label--colorsection2---national">
                <img className="arrow-img" src={Arrowwhite} alt="arrowwhite" />
            </div>
            <div className="custom_bodycontainer__mainpage--body---label--textsection3 pointernone">national news</div>
            <a className="app-user-link-a app-user-link-a--3" href="http://www.stuff.co.nz/national/quizzes/300037800/quiz-20-years-of-news-in-new-zealand" rel="noopener noreferrer" target="_self">IOS app users please click <span className="app-user-link">here</span></a>
            </div>
          </a>
          <a href="https://www.stuff.co.nz/life-style/life/121792637/a-snapshot-of-new-zealand-life-on-the-day-stuff-launched" rel="noopener noreferrer"  target="_blank"  className="custom_bodycontainer__sidebar---readmorebox--each custom_bodycontainer__sidebar---readmorebox--each---cartoon">
          <div className="custom_bodycontainer__sidebar---readmorebox--each---titlebox">
            <div className="custom_bodycontainer__mainpage--body---label--colorsection2 custom_bodycontainer__mainpage--body---label--colorsection2---national">
                <img className="arrow-img" src={Arrowwhite} alt="arrowwhite" />
            </div>
            <div className="custom_bodycontainer__mainpage--body---label--textsection3 pointernone">national news</div>
            <a className="app-user-link-a app-user-link-a--3" href="https://www.stuff.co.nz/life-style/life/121792637/a-snapshot-of-new-zealand-life-on-the-day-stuff-launched" rel="noopener noreferrer" target="_self">IOS app users please click <span className="app-user-link">here</span></a>
            </div>
          </a>
        </div>
      </div>
       );
    }
}

export default Sidebar ;